import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Formata número em pt-BR (ponto = milhar). Ex: 593775 -> "593.775". */
export function formatInt(n: number): string {
  return Math.trunc(n).toLocaleString("pt-BR");
}

/** Formata valor decimal em pt-BR. Ex: 1234.5 -> "1.234,50". */
export function formatNum(n: number, decimals = 2): string {
  return n.toLocaleString("pt-BR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

/** Formata valor monetário em R$ (pt-BR). Ex: 1234.5 -> "R$ 1.234,50". */
export function formatBRL(n: number): string {
  return `R$ ${formatNum(n, 2)}`;
}
